import { z } from 'zod';

/**
 * Validation schemas
 */

export const ChatIdSchema = z.string().uuid();
export const MessageIdSchema = z.string().uuid();
export const CognitoSubSchema = z.string().min(1);
export const EmailSchema = z.string().email();

export const CreateChatRequestSchema = z.object({
  title: z.string().optional(),
});

export const SendMessageRequestSchema = z.object({
  message: z.string().min(1).max(10000),
});

export const ShareChatRequestSchema = z.object({
  recipientEmail: EmailSchema,
});

export const UpdateChatRequestSchema = z.object({
  title: z.string().optional(),
});

export const BusinessInfoSchema = z.record(z.string(), z.any());

export const UploadBusinessInfoRequestSchema = z.object({
  businessInfo: BusinessInfoSchema,
});

/**
 * Validate request body
 */
export async function validateRequestBody<T>(
  req: Request,
  schema: z.ZodType<T>
): Promise<T> {
  try {
    const body = await req.json();
    return schema.parse(body);
  } catch (error) {
    if (error instanceof z.ZodError) {
      const messages = error.issues.map((issue) => issue.message).join(', ');
      throw new Error(`Validation error: ${messages}`);
    }
    throw error;
  }
}

